/**
 * Stable Map Layers checkbox labels for WFS + raster companion groups.
 * Keep these in sync with CompanionLevelSwitcher visibility matching.
 */
export const COMPANION_FOOTPRINT_TITLE = 'Footprint';
export const COMPANION_IMAGE_TITLE = 'Image';

export function isCompanionRoleTitle(title: string | undefined): boolean {
  if (!title) return false;
  return (
    title === COMPANION_FOOTPRINT_TITLE ||
    title.startsWith(`${COMPANION_FOOTPRINT_TITLE} `) ||
    title === COMPANION_IMAGE_TITLE ||
    title.startsWith(`${COMPANION_IMAGE_TITLE} `)
  );
}
